import type { IInquiryRepository } from '../IInquiryRepository';
import type {
  Inquiry,
  InquiryCreateRq,
  InquiryFilter,
  InquiryList,
  ProductInquiryForm,
  ProductInquiryFormFilter,
} from '../inquiry.types';
import { injectable } from 'inversify';
import qs from 'qs';
import API from '@repositories/Axios';
import type { Page } from '@type/Page';

@injectable()
export class InquiryRepository implements IInquiryRepository {
  async getOne(id: string): Promise<Inquiry> {
    const result = await API.get<Inquiry>(`/api/v1/product-inquiries/${id}`);
    return result.data;
  }

  async getList(queries?: InquiryFilter): Promise<Page<InquiryList>> {
    const queryString = qs.stringify(queries);
    const result = await API.get<Page<InquiryList>>(`/api/v1/product-inquiries?${queryString}`);
    return result.data;
  }

  async create(data: InquiryCreateRq): Promise<Inquiry> {
    const result = await API.post<Inquiry>(`/api/v1/product-inquiries`, data);
    return result.data;
  }

  async getProductInquiryForms(filter: ProductInquiryFormFilter): Promise<Page<ProductInquiryForm>> {
    const queryString = qs.stringify(filter);
    const result = await API.get<Page<ProductInquiryForm>>(`/api/v1/product-inquiry-forms?${queryString}`);
    return result.data;
  }

  update(/* id: string, data: unknown */): Promise<Inquiry> {
    throw new Error('Method not implemented.');
  }
  delete(/* id: string */): Promise<void> {
    throw new Error('Method not implemented.');
  }
}
